
export function getBoxIndicies (boxNum: number): number[][] {
  const row = Math.floor(boxNum / 3)
  const col = boxNum % 3
  const rowStartIndex = row * 3
  const colStartIndex = col * 3
  const box = []
  for (let x = 0; x < 3; x++) {
    for (let y = 0; y < 3; y++) {
      box.push([colStartIndex + x, rowStartIndex + y])
    }
  }
  return box
}

export function inverse (board: number[][][]): number[][][] {
  return board[0].map((_, y) => board.map(row => row[y]))
}

export function isComplete (board: number[][][]): boolean {
  return board.every((row) => row.every((spot) => spot.length === 1))
}

export function getSpot (num: number): number[] {
  return [num % 9, Math.floor(num / 9)]
}
